<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <patient-information :model="model" :details="true" />
      <patient-interpretation-appo-info :model="model" />
      <v-divider class="mt-4"></v-divider>
      <action-study :model="model" @setSending="setSending" />
      <!-- <v-row class="mt-4">
        <v-col cols="12" class="text-center">
          <span v-for="tab in tabs" :key="tab.value" :value="tab.value">
            <v-tooltip top :color="tab.iconColor" v-if="validAction(tab)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mt-4"
                  v-bind="attrs"
                  v-on="on"
                  @click="tab.method()"
                >
                  <span class="d-none d-sm-inline ml-12 mr-12">{{
                    tab.text
                  }}</span>
                  <span class="d-sm-none ml-2 mr-2">{{ tab.shortText }}</span>
                  <v-icon style="font-size: 25px" :color="tab.iconColor">{{
                    tab.icon
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{ tab.details }}</span>
            </v-tooltip>
          </span>
        </v-col>
      </v-row> -->
    </div>
  </div>
</template>
<script>
import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import ActionStudy from "@/app/components/image/ActionStudy.vue";
import Loader from "@/app/components/base/loader/Loader.vue";

import {
  StudyRequest,
  DownloadZipRequest,
  ReportPDFRequest,
} from "@/core/request/";

export default {
  name: "ImageInformationStudy",
  props: {
    model: Object,
  },
  components: {
    PatientInterpretationAppoInfo,
    PatientInformation,
    Encabezado,
    Loader,
    ActionStudy,
  },
  data() {
    return {
      sending: false,
      option: 0,
      tabs: [
        {
          value: 1,
          text: "Visualizador",
          shortText: "Visualizador",
          icon: "mdi-download",
          iconColor: "#F57F17",
          details: "Descarga de visualizador weasis.",
          permission: this.$prm.DOWNLOAD_DICOM,
          method: this.downloadWeasisViewer,
        },
        {
          value: 2,
          text: "Ver imágenes",
          shortText: "Imágenes",
          icon: "mdi-eye",
          iconColor: "primary",
          details: "Visualizar imágenes online.",
          permission: this.$prm.VIEWER_WEB_IMG,
          method: this.getLinkViewerOnline,
        },
        {
          value: 3,
          text: "Archivos DICOM",
          shortText: "DICOM",
          icon: "mdi-folder-download",
          iconColor: "#01579B",
          details: "Descarga de archivos DICOM en formato zip.",
          permission: this.$prm.DOWNLOAD_DICOM,
          method: this.downloadDicomZip,
        },
        {
          value: 4,
          text: "Interpretación",
          shortText: "Interpretación",
          icon: "mdi-file-pdf-box",
          iconColor: "red",
          details: "Descarga de reporte de interpretación PDF.",
          method: this.downloadInterpretation,
          display: this.validateInterpretation,
        },
      ],
    };
  },
  watch: {},
  methods: {
    downloadWeasisViewer() {
      this.sending = true;
      const params = { idStudy: this.model.idStudy };
      StudyRequest.findURLJNLP(params)
        .then(({ data }) => {
          window.open(data, "_blank").focus();
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    getLinkViewerOnline() {
      this.sending = true;
      StudyRequest.generateLinkToViewImages(this.model.idStudy)
        .then(({ data: responseData }) => {
          if (this.$utilFront.validResponse(responseData)) {
            window.open(responseData.data, "_blank").focus();
          } else {
            this.$utilFront.notifications(
              "Visualizador web, no disponible.",
              "ERROR"
            );
          }
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    downloadDicomZip() {
      this.sending = true;
      const params = { idStudy: this.model.idStudy };
      DownloadZipRequest.downloadImagesDCM(params)
        .then(({ data }) => {
          this.$utilFront.downloadZIP(
            data,
            `${this.model.idStudy}_${this.model.fullNamePatient}_DICOM.zip`
          );
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    downloadInterpretation() {
      this.sending = true;
      const params = { idStudy: this.model.idStudy };
      ReportPDFRequest.downloadInterpretation1(params)
        .then(({ data, type, status }) => {
          if (status === 200 && type != "application/json") {
            this.$utilFront.openPDF(data);
          } else {
            this.$utilFront.errorhttp(data);
          }
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    validateInterpretation() {
      return this.model.status === this.$cnst.STUDY_INTERPRETATED_STATUS;
    },
    validAction(tab) {
      return (
        (this.$utilFront.isEmpty(tab.permission) ||
          this.$utilFront.withPermission(tab.permission)) &&
        (this.$utilFront.isEmpty(tab.display) || tab.display())
      );
    },
    setSending(sending) {
      this.sending = sending;
    },
  },
};
</script>